// Helpers and modules
import observer from './libs/observer';
import detect from './helpers/detector';
import handleScroll from './helpers/handleScroll';
import prepare from './helpers/prepare';
import elements from './helpers/elements';
import { throttle, debounce } from '../../utilities/toolkit';

// Utility functions
// const throttle = (func, limit) => {
//   let lastCall = 0;
//   return (...args) => {
//     const now = Date.now();
//     if (now - lastCall >= limit) {
//       lastCall = now;
//       func(...args);
//     }
//   };
// };

// const debounce = (func, delay) => {
//   let timeout;
//   return (...args) => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func(...args), delay);
//   };
// };

// Private variables
let $aosElements = [];
let initialized = false;

// Default options
const defaultOptions = {
	offset: 120,
	delay: 0,
	easing: 'ease',
	duration: 400,
	disable: false,
	once: false,
	startEvent: 'DOMContentLoaded',
	throttleDelay: 99,
	debounceDelay: 50,
	disableMutationObserver: false,
};

let options = { ...defaultOptions };

// Refresh AOS
const refresh = (initialize = false) => {
	if (initialize) initialized = true;

	if (initialized) {
		$aosElements = prepare($aosElements, options);
		handleScroll($aosElements, options.once);
	}

	return $aosElements;
};

// Hard refresh
const refreshHard = () => {
	$aosElements = elements();
	refresh();
};

// Disable AOS
const disable = () => {
	$aosElements.forEach(({ node }) => {
		['data-aos', 'data-aos-easing', 'data-aos-duration', 'data-aos-delay'].forEach((attr) =>
			node.removeAttribute(attr)
		);
	});
};

// Check if AOS should be disabled
const isDisabled = () => {
	const { disable } = options;
	return (
		disable === true ||
		(disable === 'mobile' && detect.mobile()) ||
		(disable === 'phone' && detect.phone()) ||
		(disable === 'tablet' && detect.tablet()) ||
		(typeof disable === 'function' && disable())
	);
};

// Initialize AOS
const init = (settings = {}) => {
	options = { ...defaultOptions, ...settings };
	$aosElements = elements();

	if (isDisabled() || (document.all && !window.atob)) {
		return disable();
	}

	if (!options.disableMutationObserver && !observer.isSupported()) {
		console.info(
			'aos: MutationObserver not supported. Code mutations will not be observed automatically.'
		);
		options.disableMutationObserver = true;
	}

	document.body.setAttribute('data-aos-easing', options.easing);
	document.body.setAttribute('data-aos-duration', options.duration);
	document.body.setAttribute('data-aos-delay', options.delay);

	const startEvent = options.startEvent;
	if (
		startEvent === 'DOMContentLoaded' &&
		['complete', 'interactive'].includes(document.readyState)
	) {
		refresh(true);
	} else if (startEvent === 'load') {
		window.addEventListener('load', () => refresh(true));
	} else {
		document.addEventListener(startEvent, () => refresh(true));
	}

	window.addEventListener('resize', debounce(refresh, options.debounceDelay));
	window.addEventListener('orientationchange', debounce(refresh, options.debounceDelay));

	window.addEventListener(
		'scroll',
		throttle(() => handleScroll($aosElements, options.once), options.throttleDelay)
	);

	if (!options.disableMutationObserver) {
		observer.ready('[data-aos]', refreshHard);
	}

	return $aosElements;
};

// Export Public API
export default {
	init,
	refresh,
	refreshHard,
};
